module.exports = __webpack_public_path__ + "static/media/PushtimargImage34.12bf82fb.jpg";